import { AwardJudging } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardJudgings: (
  fetchContext: FetchContext,
  userId: number,
  accessToken?: string,
) => Promise<AwardJudging[]> = (fetchContext, userId, accessToken) => 
  fetch(`${fetchContext.baseUrl}/api/staff/judges/${userId}/awards`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => responseErrorHandler<AwardJudging[]>(fetchContext.errorStore, response, 'get award judgings'));
